<!--
 * @Author: DQL
 * @Date: 2022-04-28 11:18:16
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:21:24
 * @Description: 维保项目管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保项目管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch()"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :rules="filterParamsRules"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="企业名称"
                prop="qymc"
              >
                <el-input
                  v-model.trim="filterParams.qymc"
                  class="c-form__input"
                  placeholder="请输入企业名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目地址"
                prop="xmdz"
              >
                <el-input
                  v-model.trim="filterParams.xmdz"
                  class="c-form__input"
                  placeholder="请输入项目地址"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属账号"
                prop="sszh"
              >
                <el-input
                  v-model.trim="filterParams.sszh"
                  class="c-form__input"
                  placeholder="请输入所属账号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'gzwxView', params: { xmId: scope.row.xmId} })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>

            <template
              #zddw="scope"
            >
              {{ scope.row.zddw === 'Y' ? '是' : '否' }}
            </template>

            <template
              #htrq="scope"
            >
              <span
                :class="{
                  'u-text-danger': !scope.row.htyxqQ
                }"
              >
                <template v-if="scope.row.htyxqQ">
                  {{ scope.row.htyxqQ | date('yyyy-MM-dd') }}
                  至
                  {{ scope.row.htyxqZ | date('yyyy-MM-dd') }}
                </template>
                <template v-else>缺合同</template>
              </span>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        已出过报告的项目不可删除
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { wbxmService } from '@/features/xfwbgl/wbxm/wbxm.service';

export default {
  name: 'Wbrw',
  components: {
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        areaDm: null, // 所属区域
        xmmc: null, // 项目名称
        xmdz: null,
        qymc: null,
        sszh: null,
        cjsjQZ: [null, null]
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        cjsjQZ: [this.$HMValidator.dateRange('开始时间')]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'wtdw', label: '企业名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'xmdz', label: '项目地址', align: 'left', minWidth: '180', type: 'text' },
        { key: 'zddw', slotName: 'zddw', label: '重点单位', width: '60', align: 'center', type: 'text' },
        { key: 'htrq', slotName: 'htrq', label: '合同有效期', align: 'center', width: '180', type: 'date' },
        { key: 'jzs', label: '建筑数', align: 'left', width: '60', type: 'text' },
        { key: 'sszhMc', label: '所属账号', align: 'left', width: '80', type: 'text' },
        // { key: 'lrdw', label: '录入单位', align: 'left', minWidth: '130', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'left', width: '125', type: 'dateTime' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 End */

      statusOption: [
        { id: '1', text: '1' }
      ]

    };
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      [this.trueFilterParams.cjsjq, this.trueFilterParams.cjsjz] = this.trueFilterParams.cjsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      wbxmService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此维保项目信息：${_row.xmmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wbxmService.delete(_row.xmId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('维保项目删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      wbxmService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>

<style scoped lang="scss">
.o-tips {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 9;
  padding: 6px 12px;
  padding-left: 8px;
  margin: 0 2px;
  border-left: 0;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5em;
  color: #f56c6c;
  background-color: #fff6f7;
}
</style>
